/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class adjudicationdetail extends IceEntity {
  adjudication_detail_key: string = "";
  claim_adjustment_group_code: string = "";
  claim_adjustment_reason_code: string = "";
  amount: number = 0.0;
  quantity: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "ADJUDICATION_DETAIL";
  }
}
